var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07989 6.61998V6.91998H9.37989H14.05L14.0503 6.92011H14.1202C14.7173 6.92011 15.2001 7.40431 15.2 8.00001V8.00007C15.2 8.59714 14.7158 9.08002 14.12 9.08002H9.38002H9.08003L9.08002 9.38001L9.07989 14.12C9.07989 14.7171 8.59569 15.2 7.99993 15.2C7.40286 15.2 6.91998 14.7158 6.91998 14.12V9.38002V9.08002H6.61998H1.87995C1.28288 9.08002 0.8 8.59585 0.8 8.00007C0.8 7.40428 1.28288 6.92011 1.87995 6.92011H1.87996L6.61999 6.91998L6.91998 6.91997V6.61998V1.87995C6.91998 1.28288 7.40418 0.8 7.99993 0.8C8.59701 0.8 9.07989 1.2842 9.07989 1.87995V6.61998Z",
    fill: "#49454F",
    stroke: "white",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusImg);
export default __webpack_public_path__ + "static/media/plusImg.ff1c2537c9941604faf73bee5d743cde.svg";
export { ForwardRef as ReactComponent };